import { isLongTextField, isOverlayableText } from './shared'

/**
 * Short text replaces the string in place. Long text keeps the `{ text }` wrapper that
 * `gatsby-source-contentful` adds around the field.
 */
export const overlayText = (value: unknown, field: unknown): unknown | undefined => {
  if (!isOverlayableText(field)) return undefined
  if (typeof value === 'string') return field
  if (isLongTextField(value)) return { ...value, text: field }
  return undefined
}
